<template>
  <md-table-row v-if="item">
    <md-table-cell class="align-bottom pb-3"
      ><div class="flex items-center w-52">
        <img
          :src="item.avatar_url || '/img/avt_placeholder.jpg'"
          class="object-cover rounded-full w-[42px] h-[42px]"
        />
        <div class="text-left pl-4">
          <p class="font-medium">{{ item.full_name }}</p>
          <p class="font-medium">{{ item.student_code }}</p>
        </div>
      </div>
    </md-table-cell>
    <md-table-cell class="align-bottom pb-6">{{ item.email }}</md-table-cell>
    <md-table-cell class="align-bottom pb-6">{{
      item.class && item.class.name
    }}</md-table-cell>
    <md-table-cell class="align-bottom"
      ><isis-time-picker
        :disabled="canUpdate"
        v-model="item.from_join_time"
        class="m-0 leading-[5px]"
      >
      </isis-time-picker
    ></md-table-cell>
    <md-table-cell class="align-bottom"
      ><isis-time-picker
        :disabled="canUpdate"
        v-model="item.from_leave_time"
        class="m-0 leading-[5px]"
      >
      </isis-time-picker>
    </md-table-cell>
    <md-table-cell class="align-bottom"
      ><md-field class="mb-0">
        <label :for="select.name">{{ $t(select.label) }}</label>
        <md-select
          :disabled="canUpdate"
          v-model.trim="item.status"
          :name="select.name"
          :id="select.name"
          :multiple="select.multiple"
          class="text-red-500"
        >
          <md-option
            class="text-red-600"
            v-for="option in select.options"
            :value="option.id"
            :key="option.id + option.name"
            >{{ $t(option.name) }}
          </md-option>
        </md-select>
      </md-field></md-table-cell
    >
    <md-table-cell class="align-bottom pt-5">
      <md-field class="field-comment">
        <md-textarea
          :disabled="canUpdate"
          class="max-h-[100px] min-h-[36px]"
          md-autogrow
          :placeholder="$t('smi_sri.comment')"
          v-model="item.description"
        ></md-textarea>
      </md-field>
    </md-table-cell>
  </md-table-row>
</template>
<script>
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import { service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { ZoomMeeting } from "@/constants/Permissions";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";

export default {
  props: ["itemProps", "currentTimezone", "canUpdate"],
  data() {
    return {
      item: this.itemProps,
      serverFormat: "YYYY-MM-DD HH:mm:ss",
      select: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: [
          {
            id: "Present",
            name: "attendance_report.student.present"
          },
          {
            id: "Ex.absence",
            name: "attendance_report.student.excused_absence"
          },
          {
            id: "Ex.tardy",
            name: "attendance_report.student.excused_tardy"
          },
          {
            id: "Unex.absence",
            name: "attendance_report.student.unexcused_absence"
          },
          {
            id: "Unex.tardy",
            name: "attendance_report.student.unexcused_tardy"
          }
        ]
      }
    };
  }
};
</script>
<style lang="scss">
.field-comment {
  margin-bottom: 0 !important;
}
</style>
